import { Company, WorkCenterViewModel } from '../Incrementals.types';
import { UiQueries } from './UiQueries';

export function getCompaniesThatCanBeAssociatedQuery(
  this: UiQueries,
  workCenter: WorkCenterViewModel
): Company[] {
  const companiesThatCanBeAssociated = this.uiState.companies.filter(
    (companyElement) => {
      const alreadyAssociated = workCenter.companies.filter(
        (associatedCompanyElement) =>
          associatedCompanyElement.company === companyElement.company
      );

      const requestedToBeAssociated = workCenter.companiesToAssociate.filter(
        (companyToAssociate) =>
          companyToAssociate.company === companyElement.company
      );

      // if the company is already associated for requested to be associated (in-memory but not yet via api),
      // then an in-memory association request cannot be made
      return (
        alreadyAssociated.length === 0 && requestedToBeAssociated.length === 0
      );
    }
  );

  return companiesThatCanBeAssociated;
}
